// Experience.js
import React from "react";
import "./experience.css";
import { experienceData } from "./data";

function Experience() {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>My Experience</h2>
      <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            {experienceData.frontend.map((skill, index) => (
              <article key={index} className="experience_details">
                <i className="fa-solid fa-check"></i>
                <div>
                  <h4>{skill.name}</h4>
                  <small className="text-light">{skill.level}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
        <div className="experience_backend">
          <h3>Backend Development</h3>
          <div className="experience_content">
            {experienceData.backend.map((skill, index) => (
              <article key={index} className="experience_details">
                <i className="fa-solid fa-check"></i>
                <div>
                  <h4>{skill.name}</h4>
                  <small className="text-light">{skill.level}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;
